import React from 'react';

import { StationResponseType } from '@.api/methods';
import { useTabs } from '@.hooks';
import { Filters } from '@.partials';
import { Filter3, FilterData } from '@.ui';
import { PermissionProps } from '@/Types';

import { Firmware, General, Logs, Products, Statistics } from '../ui/components';

interface UseStationTabsParameters {
    station?: StationResponseType;
    statisticFiltersOnChange: (query: FilterData) => void;
    filterData?: FilterData;
    productsFiltersOnChange: (query: FilterData) => void;
    logsFiltersOnChange: (query: FilterData) => void;
    /**
     * TODO: need change on correct type.
     */
    permissions: PermissionProps['permissions'];
}

export const useStationTabs = (parameters: UseStationTabsParameters) => {
    const { statisticFiltersOnChange, station, filterData, productsFiltersOnChange, permissions, logsFiltersOnChange } = parameters;

    const [stationTabsControls, [stationTabsFilters, stationTabsContent], stationTabsPath] = useTabs<[React.ReactNode, React.ReactNode]>([
        {
            name: 'General',
            path: 'general',
            is_default: true,
            content: [null, <General key={station?.id} station={station} />],
        },
        {
            name: 'Devices',
            path: 'devices',
            content: [null, <Firmware key={station?.id} station={station} />],
        },
        {
            name: 'Statistic',
            path: 'statistic',
            content: [
                <Filter3 key={station?.id} onChange={statisticFiltersOnChange}>
                    <Filter3.Date switcher />
                </Filter3>,
                <Statistics key={station?.id} station={station} filters={filterData} />,
            ],
        },
        {
            name: 'Products',
            path: 'products',
            content: [
                <Filters key={station?.id} onChange={productsFiltersOnChange} />,
                <Products key={station?.id} station={station} filters={filterData} permissions={permissions} />,
            ],
        },
        {
            name: 'Logs',
            path: 'logs',
            content: [
                <Filters key={station?.id} filters={['StationLogTypes']} onChange={logsFiltersOnChange} date="full" visibleLabel="" />,
                <Logs key={station?.id} station={station} filters={filterData} />,
            ],
        },
    ]);

    return {
        stationTabsContent,
        stationTabsControls,
        stationTabsFilters,
        stationTabsPath,
    };
};
